import i18n from "@/localization/i18next";
import { SubscriptionsPeriods } from "@/types/price";
import { PricePoint } from "@palta-brain/payments";

import { CurrencyCodes } from "./currency";

export const PALTA_PAYMENTS_V2_API_KEY =
    process.env.REACT_APP_PALTA_PAYMENTS_V2_API_KEY || "acc078a2a51543ce9188b5c7e8fad1da";

export const enum PricePlansIds {
    // USD plans
    zing_premium_1w_7_99_intro_7_99_usd = "zing_premium_1w_7_99_intro_7_99_usd",
    zing_premium_1m_38_95_7d_trial_6_93_usd = "zing_premium_1m_38_95_7d_trial_6_93_usd",
    zing_premium_1m_38_95_7d_trial_5_15_usd = "zing_premium_1m_38_95_7d_trial_5_15_usd",
    zing_premium_1m_38_95_intro_15_99_usd = "zing_premium_1m_38_95_intro_15_99_usd",
    zing_premium_1m_38_95_intro_11_29_usd = "zing_premium_1m_38_95_intro_11_29_usd",
    zing_premium_3m_66_65_intro_25_99_usd = "zing_premium_3m_66_65_intro_25_99_usd",
    zing_premium_3m_66_65_intro_19_29_usd = "zing_premium_3m_66_65_intro_19_29_usd",
    zing_premium_3m_59_99_intro_44_00_usd = "zing_premium_3m_59_99_intro_44_00_usd",
    zing_premium_3m_47_99_intro_32_00_usd = "zing_premium_3m_47_99_intro_32_00_usd",
    zing_premium_3m_59_99_intro_48_70_usd = "zing_premium_3m_59_99_intro_48_70_usd",
    zing_premium_3m_47_99_intro_36_70_usd = "zing_premium_3m_47_99_intro_36_70_usd",
    zing_premium_12m_104_46_intro_78_47_usd = "zing_premium_12m_104_46_intro_78_47_usd",
    zing_premium_12m_83_67_intro_57_68_usd = "zing_premium_12m_83_67_intro_57_68_usd",
    zing_premium_12m_104_46_intro_85_17_usd = "zing_premium_12m_104_46_intro_85_17_usd",
    zing_premium_12m_83_67_intro_64_38_usd = "zing_premium_12m_83_67_intro_64_38_usd",
    zing_premium_12m_89_99_7d_trial_0_usd = "zing_premium_12m_89_99_7d_trial_0_usd",
    zing_premium_12m_109_99_intro_65_99_usd = "zing_premium_12m_109_99_intro_65_99_usd",
    zing_premium_bodyscan_12m_139_99_intro_69_99_usd = "zing_premium_bodyscan_12m_139_99_intro_69_99_usd",

    zing_premium_bodyscan_1m_27_59_intro_19_60_usd = "zing_premium_bodyscan_1m_27_59_intro_19_60_usd",
    zing_premium_bodyscan_1m_34_49_intro_26_50_usd = "zing_premium_bodyscan_1m_34_49_intro_26_50_usd",

    //influencer offer funnel
    zing_premium_bodyscan_1m_18_39_intro_18_39_usd = "zing_premium_bodyscan_1m_18_39_intro_18_39_usd",
    zing_premium_bodyscan_12m_69_99_intro_69_99_usd = "zing_premium_bodyscan_12m_69_99_intro_69_99_usd",
    zing_premium_bodyscan_lifetime_139_99_usd = "zing_premium_bodyscan_lifetime_139_99_usd",

    //cohort without intro offer test prices
    zing_premium_bodyscan_1w_7_99_intro_7_99_usd = "zing_premium_bodyscan_1w_7_99_intro_7_99_usd",
    zing_premium_bodyscan_3m_29_99_intro_29_99_usd = "zing_premium_bodyscan_3m_29_99_intro_29_99_usd",

    //old male funnel exp prices
    zing_premium_1m_29_84_intro_13_99_usd = "zing_premium_1m_29_84_intro_13_99_usd",
    zing_premium_3m_44_77_intro_21_99_usd = "zing_premium_3m_44_77_intro_21_99_usd",
    zing_premium_12m_104_46_intro_54_99_usd = "zing_premium_12m_104_46_intro_54_99_usd",

    // new paywall
    zing_premium_bodyscan_1m_37_99_intro_18_99_usd = "zing_premium_bodyscan_1m_37_99_intro_18_99_usd",
    zing_premium_bodyscan_3m_59_99_intro_29_99_usd = "zing_premium_bodyscan_3m_59_99_intro_29_99_usd",

    // GBP plans
    zing_premium_1w_7_99_intro_7_99_gbp = "zing_premium_1w_7_99_intro_7_99_gbp",
    zing_premium_1m_38_95_7d_trial_6_93_gbp = "zing_premium_1m_38_95_7d_trial_6_93_gbp",
    zing_premium_1m_38_95_intro_15_99_gbp = "zing_premium_1m_38_95_intro_15_99_gbp",
    zing_premium_3m_66_65_intro_25_99_gbp = "zing_premium_3m_66_65_intro_25_99_gbp",
    zing_premium_3m_59_99_intro_44_00_gbp = "zing_premium_3m_59_99_intro_44_00_gbp",
    zing_premium_3m_47_99_intro_32_00_gbp = "zing_premium_3m_47_99_intro_32_00_gbp",
    zing_premium_12m_104_46_intro_78_47_gbp = "zing_premium_12m_104_46_intro_78_47_gbp",
    zing_premium_12m_83_67_intro_57_68_gbp = "zing_premium_12m_83_67_intro_57_68_gbp",
    zing_premium_12m_89_99_7d_trial_0_gbp = "zing_premium_12m_89_99_7d_trial_0_gbp",
    zing_premium_bodyscan_1w_6_99_intro_6_99_gbp = "zing_premium_bodyscan_1w_6_99_intro_6_99_gbp",
    zing_premium_bodyscan_1m_29_99_intro_14_99_gbp = "zing_premium_bodyscan_1m_29_99_intro_14_99_gbp",
    zing_premium_bodyscan_1m_34_97_intro_13_99_gbp = "zing_premium_bodyscan_1m_34_97_intro_13_99_gbp",
    zing_premium_bodyscan_3m_49_99_intro_24_99_gbp = "zing_premium_bodyscan_3m_49_99_intro_24_99_gbp",
    zing_premium_bodyscan_3m_59_98_intro_23_99_gbp = "zing_premium_bodyscan_3m_59_98_intro_23_99_gbp",

    // CAD plans
    zing_premium_1w_10_99_intro_10_99_cad = "zing_premium_1w_10_99_intro_10_99_cad",
    zing_premium_1m_48_76_7d_trial_8_93_cad = "zing_premium_1m_48_76_7d_trial_8_93_cad",
    zing_premium_1m_48_76_intro_19_99_cad = "zing_premium_1m_48_76_intro_19_99_cad",
    zing_premium_3m_82_90_intro_33_99_cad = "zing_premium_3m_82_90_intro_33_99_cad",
    zing_premium_3m_79_99_intro_60_00_cad = "zing_premium_3m_79_99_intro_60_00_cad",
    zing_premium_3m_63_99_intro_44_00_cad = "zing_premium_3m_63_99_intro_44_00_cad",
    zing_premium_12m_139_99_intro_106_00_cad = "zing_premium_12m_139_99_intro_106_00_cad",
    zing_premium_12m_109_99_intro_76_00_cad = "zing_premium_12m_109_99_intro_76_00_cad",
    zing_premium_12m_125_99_7d_trial_0_cad = "zing_premium_12m_125_99_7d_trial_0_cad",
    zing_premium_bodyscan_1w_8_99_intro_8_99_cad = "zing_premium_bodyscan_1w_8_99_intro_8_99_cad",
    zing_premium_bodyscan_1m_43_99_intro_21_99_cad = "zing_premium_bodyscan_1m_43_99_intro_21_99_cad",
    zing_premium_bodyscan_1m_47_48_intro_18_99_cad = "zing_premium_bodyscan_1m_47_48_intro_18_99_cad",
    zing_premium_bodyscan_3m_67_99_intro_33_99_cad = "zing_premium_bodyscan_3m_67_99_intro_33_99_cad",
    zing_premium_bodyscan_3m_74_98_intro_29_99_cad = "zing_premium_bodyscan_3m_74_98_intro_29_99_cad",

    // AUD plans
    zing_premium_1w_11_99_intro_11_99_aud = "zing_premium_1w_11_99_intro_11_99_aud",
    zing_premium_1m_58_95_7d_trial_9_99_aud = "zing_premium_1m_58_95_7d_trial_9_99_aud",
    zing_premium_1m_58_95_intro_22_99_aud = "zing_premium_1m_58_95_intro_22_99_aud",
    zing_premium_3m_97_41_intro_37_99_aud = "zing_premium_3m_97_41_intro_37_99_aud",
    zing_premium_3m_71_99_intro_49_00_aud = "zing_premium_3m_71_99_intro_49_00_aud",
    zing_premium_3m_89_99_intro_67_00_aud = "zing_premium_3m_89_99_intro_67_00_aud",
    zing_premium_12m_111_99_intro_74_00_aud = "zing_premium_12m_111_99_intro_74_00_aud",
    zing_premium_12m_139_99_intro_102_00_aud = "zing_premium_12m_139_99_intro_102_00_aud",
    zing_premium_12m_138_99_7d_trial_0_aud = "zing_premium_12m_138_99_7d_trial_0_aud",
    zing_premium_bodyscan_1w_10_99_intro_10_99_aud = "zing_premium_bodyscan_1w_10_99_intro_10_99_aud",
    zing_premium_bodyscan_1m_49_99_intro_24_99_aud = "zing_premium_bodyscan_1m_49_99_intro_24_99_aud",
    zing_premium_bodyscan_1m_49_98_intro_19_99_aud = "zing_premium_bodyscan_1m_49_98_intro_19_99_aud",
    zing_premium_bodyscan_3m_79_99_intro_39_99_aud = "zing_premium_bodyscan_3m_79_99_intro_39_99_aud",
    zing_premium_bodyscan_3m_82_48_intro_32_99_aud = "zing_premium_bodyscan_3m_82_48_intro_32_99_aud",

    // EUR plans
    zing_premium_1w_7_99_intro_7_99_eur = "zing_premium_1w_7_99_intro_7_99_eur",
    zing_premium_1m_38_95_7d_trial_6_93_eur = "zing_premium_1m_38_95_7d_trial_6_93_eur",
    zing_premium_1m_38_95_intro_15_99_eur = "zing_premium_1m_38_95_intro_15_99_eur",
    zing_premium_3m_66_65_intro_25_99_eur = "zing_premium_3m_66_65_intro_25_99_eur",
    zing_premium_3m_47_99_intro_32_00_eur = "zing_premium_3m_47_99_intro_32_00_eur",
    zing_premium_3m_59_99_intro_44_00_eur = "zing_premium_3m_59_99_intro_44_00_eur",
    zing_premium_12m_83_67_intro_57_68_eur = "zing_premium_12m_83_67_intro_57_68_eur",
    zing_premium_12m_104_46_intro_78_47_eur = "zing_premium_12m_104_46_intro_78_47_eur",
    zing_premium_12m_85_99_7d_trial_0_eur = "zing_premium_12m_85_99_7d_trial_0_eur",
    zing_premium_12m_104_99_intro_62_99_eur = "zing_premium_12m_104_99_intro_62_99_eur",
    zing_premium_bodyscan_1w_7_99_intro_7_99_eur = "zing_premium_bodyscan_1w_7_99_intro_7_99_eur",
    zing_premium_bodyscan_1m_37_99_intro_18_99_eur = "zing_premium_bodyscan_1m_37_99_intro_18_99_eur",
    zing_premium_bodyscan_1m_38_95_intro_15_99_eur = "zing_premium_bodyscan_1m_38_95_intro_15_99_eur",
    zing_premium_bodyscan_3m_59_99_intro_29_99_eur = "zing_premium_bodyscan_3m_59_99_intro_29_99_eur",
    zing_premium_bodyscan_3m_66_65_intro_25_99_eur = "zing_premium_bodyscan_3m_66_65_intro_25_99_eur",

    // MXN plans
    zing_premium_1w_89_intro_89_mxn = "zing_premium_1w_89_intro_89_mxn",
    zing_premium_1m_439_00_7d_trial_79_99_mxn = "zing_premium_1m_439_00_7d_trial_79_99_mxn",
    zing_premium_1m_419_intro_209_mxn = "zing_premium_1m_419_intro_209_mxn",
    zing_premium_3m_731_70_intro_299_99_mxn = "zing_premium_3m_731_70_intro_299_99_mxn",
    zing_premium_3m_659_intro_329_mxn = "zing_premium_3m_659_intro_329_mxn",
    zing_premium_1m_439_00_intro_179_99_mxn = "zing_premium_1m_439_00_intro_179_99_mxn",
    zing_premium_12m_1199_99_intro_900_00_mxn = "zing_premium_12m_1199_99_intro_900_00_mxn",
    zing_premium_3m_699_99_intro_520_00_mxn = "zing_premium_3m_699_99_intro_520_00_mxn",
    zing_premium_12m_999_99_intro_700_00_mxn = "zing_premium_12m_999_99_intro_700_00_mxn",
    zing_premium_3m_559_99_intro_380_00_mxn = "zing_premium_3m_559_99_intro_380_00_mxn",
    zing_premium_bodyscan_1w_89_intro_89_mxn = "zing_premium_bodyscan_1w_89_intro_89_mxn",
    zing_premium_bodyscan_1m_419_intro_209_mxn = "zing_premium_bodyscan_1m_419_intro_209_mxn",
    zing_premium_bodyscan_3m_659_intro_329_mxn = "zing_premium_bodyscan_3m_659_intro_329_mxn",

    // ARS plans
    zing_premium_1w_4699_intro_4699_ars = "zing_premium_1w_4699_intro_4699_ars",
    zing_premium_1m_22899_intro_9399_ars = "zing_premium_1m_22899_intro_9399_ars",
    zing_premium_3m_39199_intro_15299_ars = "zing_premium_3m_39199_intro_15299_ars",

    // CLP plans
    zing_premium_1w_5190_intro_5190_clp = "zing_premium_1w_5190_intro_5190_clp",
    zing_premium_1m_24990_intro_10490_clp = "zing_premium_1m_24990_intro_10490_clp",
    zing_premium_3m_42990_intro_16990_clp = "zing_premium_3m_42990_intro_16990_clp",

    // promo plans
    zing_premium_12m_39_99_7d_trial_1_usd = "zing_premium_12m_39_99_7d_trial_1_usd",
    zing_premium_1m_29_84_7d_trial_1_gbp = "zing_premium_1m_29_84_7d_trial_1_gbp",
    zing_premium_1m_38_79_7d_trial_1_cad = "zing_premium_1m_38_79_7d_trial_1_cad",
    zing_premium_1m_43_27_7d_trial_1_aud = "zing_premium_1m_43_27_7d_trial_1_aud",
    zing_premium_1m_27_99_7d_trial_1_eur = "zing_premium_1m_27_99_7d_trial_1_eur",
    zing_premium_12m_104_46_7d_1_usd = "zing_premium_12m_104_46_7d_1_usd",
    zing_premium_12m_59_99_7d_trial_0_usd = "zing_premium_12m_59_99_7d_trial_0_usd",
    zing_premium_12m_104_46_7d_1_gbp = "zing_premium_12m_104_46_7d_1_gbp",
    zing_premium_12m_59_99_7d_trial_0_gpb = "zing_premium_12m_59_99_7d_trial_0_gpb",
    zing_premium_12m_134_30_7d_1_cad = "zing_premium_12m_134_30_7d_1_cad",
    zing_premium_12m_81_46_7d_trial_0_cad = "zing_premium_12m_81_46_7d_trial_0_cad",
    zing_premium_12m_149_24_7d_1_aud = "zing_premium_12m_149_24_7d_1_aud",
    zing_premium_12m_89_99_7d_trial_0_aud = "zing_premium_12m_89_99_7d_trial_0_aud",
    zing_premium_12m_95_99_7d_0_eur = "zing_premium_12m_95_99_7d_0_eur",
    zing_premium_12m_54_10_7d_trial_0_eur = "zing_premium_12m_54_10_7d_trial_0_eur",
    zing_premium_1m_329_99_7d_trial_10_99_mxn = "zing_premium_1m_329_99_7d_trial_10_99_mxn",
    zing_premium_12m_658_7d_trial_0_mxn = "zing_premium_12m_658_7d_trial_0_mxn",

    // new upgrade flow prices
    zing_premium_1m_29_99_intro_23_06_usd = "zing_premium_1m_29_99_intro_23_06_usd",
    zing_premium_1m_23_99_intro_17_06_usd = "zing_premium_1m_23_99_intro_17_06_usd",

    zing_premium_bodyscan_1m_44_79_7d_trial_7_99_usd = "zing_premium_bodyscan_1m_44_79_7d_trial_7_99_usd",
    zing_premium_bodyscan_1m_44_79_intro_18_39_usd = "zing_premium_bodyscan_1m_44_79_intro_18_39_usd",
    zing_premium_bodyscan_3m_76_59_intro_29_99_usd = "zing_premium_bodyscan_3m_76_59_intro_29_99_usd",
    zing_premium_bodyscan_3m_68_99_intro_50_60_usd = "zing_premium_bodyscan_3m_68_99_intro_50_60_usd",
    zing_premium_bodyscan_3m_55_29_intro_36_90_usd = "zing_premium_bodyscan_3m_55_29_intro_36_90_usd",
    zing_premium_bodyscan_12m_119_99_intro_90_00_usd = "zing_premium_bodyscan_12m_119_99_intro_90_00_usd",
    zing_premium_bodyscan_12m_96_49_intro_66_50_usd = "zing_premium_bodyscan_12m_96_49_intro_66_50_usd",

    zing_premium_bodyscan_1m_44_99_7d_trial_7_99_gbp = "zing_premium_bodyscan_1m_44_99_7d_trial_7_99_gbp",
    zing_premium_bodyscan_1m_44_99_intro_18_99_gbp = "zing_premium_bodyscan_1m_44_99_intro_18_99_gbp",
    zing_premium_bodyscan_3m_76_99_intro_29_99_gbp = "zing_premium_bodyscan_3m_76_99_intro_29_99_gbp",
    zing_premium_bodyscan_3m_68_99_intro_50_00_gbp = "zing_premium_bodyscan_3m_68_99_intro_50_00_gbp",
    zing_premium_bodyscan_3m_54_99_intro_36_00_gbp = "zing_premium_bodyscan_3m_54_99_intro_36_00_gbp",
    zing_premium_bodyscan_12m_119_99_intro_90_00_gbp = "zing_premium_bodyscan_12m_119_99_intro_90_00_gbp",
    zing_premium_bodyscan_12m_95_99_intro_66_00_gbp = "zing_premium_bodyscan_12m_95_99_intro_66_00_gbp",

    zing_premium_bodyscan_1m_41_99_7d_trial_7_49_eur = "zing_premium_bodyscan_1m_41_99_7d_trial_7_49_eur",
    zing_premium_bodyscan_1m_41_99_intro_17_39_eur = "zing_premium_bodyscan_1m_41_99_intro_17_39_eur",
    zing_premium_bodyscan_3m_71_99_intro_28_19_eur = "zing_premium_bodyscan_3m_71_99_intro_28_19_eur",
    zing_premium_bodyscan_3m_64_99_intro_47_60_eur = "zing_premium_bodyscan_3m_64_99_intro_47_60_eur",
    zing_premium_bodyscan_3m_51_99_intro_34_60_eur = "zing_premium_bodyscan_3m_51_99_intro_34_60_eur",
    zing_premium_bodyscan_12m_112_69_intro_84_50_eur = "zing_premium_bodyscan_12m_112_69_intro_84_50_eur",
    zing_premium_bodyscan_12m_90_69_intro_62_50_eur = "zing_premium_bodyscan_12m_90_69_intro_62_50_eur",

    zing_premium_bodyscan_1m_57_69_7d_trial_11_99_aud = "zing_premium_bodyscan_1m_57_69_7d_trial_11_99_aud",
    zing_premium_bodyscan_1m_57_69_intro_27_79_aud = "zing_premium_bodyscan_1m_57_69_intro_27_79_aud",
    zing_premium_bodyscan_3m_115_69_intro_45_39_aud = "zing_premium_bodyscan_3m_115_69_intro_45_39_aud",
    zing_premium_bodyscan_3m_104_99_intro_77_20_aud = "zing_premium_bodyscan_3m_104_99_intro_77_20_aud",
    zing_premium_bodyscan_3m_83_49_intro_55_70_aud = "zing_premium_bodyscan_3m_83_49_intro_55_70_aud",
    zing_premium_bodyscan_12m_180_99_intro_135_60_aud = "zing_premium_bodyscan_12m_180_99_intro_135_60_aud",
    zing_premium_bodyscan_12m_145_69_intro_100_30_aud = "zing_premium_bodyscan_12m_145_69_intro_100_30_aud",

    zing_premium_bodyscan_1m_61_39_7d_trial_10_89_cad = "zing_premium_bodyscan_1m_61_39_7d_trial_10_89_cad",
    zing_premium_bodyscan_1m_61_39_intro_25_19_cad = "zing_premium_bodyscan_1m_61_39_intro_25_19_cad",
    zing_premium_bodyscan_3m_104_99_intro_40_99_cad = "zing_premium_bodyscan_3m_104_99_intro_40_99_cad",
    zing_premium_bodyscan_3m_94_49_intro_69_30_cad = "zing_premium_bodyscan_3m_94_49_intro_69_30_cad",
    zing_premium_bodyscan_3m_75_69_intro_50_50_cad = "zing_premium_bodyscan_3m_75_69_intro_50_50_cad",
    zing_premium_bodyscan_12m_164_39_intro_123_40_cad = "zing_premium_bodyscan_12m_164_39_intro_123_40_cad",
    zing_premium_bodyscan_12m_131_99_intro_91_00_cad = "zing_premium_bodyscan_12m_131_99_intro_91_00_cad",

    // body scan to sub
    zing_premium_bodyscan_1m_38_95_7d_trial_6_93_usd = "zing_premium_bodyscan_1m_38_95_7d_trial_6_93_usd",
    zing_premium_bodyscan_1m_38_95_intro_15_99_usd = "zing_premium_bodyscan_1m_38_95_intro_15_99_usd",
    zing_premium_bodyscan_3m_66_65_intro_25_99_usd = "zing_premium_bodyscan_3m_66_65_intro_25_99_usd",
    zing_premium_bodyscan_3m_59_99_intro_44_00_usd = "zing_premium_bodyscan_3m_59_99_intro_44_00_usd",
    zing_premium_bodyscan_3m_47_99_intro_32_00_usd = "zing_premium_bodyscan_3m_47_99_intro_32_00_usd",
    zing_premium_bodyscan_12m_104_46_intro_78_47_usd = "zing_premium_bodyscan_12m_104_46_intro_78_47_usd",
    zing_premium_bodyscan_12m_83_67_intro_57_68_usd = "zing_premium_bodyscan_12m_83_67_intro_57_68_usd",

    // plans without discount
    zing_premium_bodyscan_3m_59_99_intro_59_99_usd = "zing_premium_bodyscan_3m_59_99_intro_59_99_usd",
    zing_premium_bodyscan_1m_37_99_intro_37_99_usd = "zing_premium_bodyscan_1m_37_99_intro_37_99_usd",
    zing_premium_bodyscan_1w_15_99_intro_15_99_usd = "zing_premium_bodyscan_1w_15_99_intro_15_99_usd",
    zing_premium_bodyscan_1w_15_99_intro_15_99_eur = "zing_premium_bodyscan_1w_15_99_intro_15_99_eur",
    zing_premium_bodyscan_1m_37_99_intro_37_99_eur = "zing_premium_bodyscan_1m_37_99_intro_37_99_eur",
    zing_premium_bodyscan_3m_59_99_intro_59_99_eur = "zing_premium_bodyscan_3m_59_99_intro_59_99_eur",
    zing_premium_bodyscan_1w_13_99_intro_13_99_gbp = "zing_premium_bodyscan_1w_13_99_intro_13_99_gbp",
    zing_premium_bodyscan_1m_29_99_intro_29_99_gbp = "zing_premium_bodyscan_1m_29_99_intro_29_99_gbp",
    zing_premium_bodyscan_3m_49_99_intro_49_99_gbp = "zing_premium_bodyscan_3m_49_99_intro_49_99_gbp",
    zing_premium_bodyscan_1w_21_99_intro_21_99_aud = "zing_premium_bodyscan_1w_21_99_intro_21_99_aud",
    zing_premium_bodyscan_1m_49_99_intro_49_99_aud = "zing_premium_bodyscan_1m_49_99_intro_49_99_aud",
    zing_premium_bodyscan_3m_79_99_intro_79_99_aud = "zing_premium_bodyscan_3m_79_99_intro_79_99_aud",
    zing_premium_bodyscan_1w_17_99_intro_17_99_cad = "zing_premium_bodyscan_1w_17_99_intro_17_99_cad",
    zing_premium_bodyscan_1m_43_99_intro_43_99_cad = "zing_premium_bodyscan_1m_43_99_intro_43_99_cad",
    zing_premium_bodyscan_3m_67_99_intro_67_99_cad = "zing_premium_bodyscan_3m_67_99_intro_67_99_cad",
    zing_premium_bodyscan_1w_179_99_intro_179_99_mxn = "zing_premium_bodyscan_1w_179_99_intro_179_99_mxn",
    zing_premium_bodyscan_1m_419_intro_419_mxn = "zing_premium_bodyscan_1m_419_intro_419_mxn",
    zing_premium_bodyscan_3m_659_intro_659_mxn = "zing_premium_bodyscan_3m_659_intro_659_mxn",
}

export const getPricePlansIds = ({
    isOfferFlow,
    isYearPlanExp,
}: {
    isOfferFlow?: boolean;
    isYearPlanExp?: boolean;
}) => {
    if (isOfferFlow) {
        return OFFER_FUNNEL_PRICE_PLANS_IDS_BY_CURRENCY;
    }
    return PRICE_PLANS_IDS_BY_CURRENCY(isYearPlanExp);
};

export const EMAIL_MB_PLANS_IDS: Record<CurrencyCodes, PricePlansIds> = {
    [CurrencyCodes.USD]: PricePlansIds.zing_premium_12m_39_99_7d_trial_1_usd,
    [CurrencyCodes.GBP]: PricePlansIds.zing_premium_1m_29_84_7d_trial_1_gbp,
    [CurrencyCodes.CAD]: PricePlansIds.zing_premium_1m_38_79_7d_trial_1_cad,
    [CurrencyCodes.AUD]: PricePlansIds.zing_premium_1m_43_27_7d_trial_1_aud,
    [CurrencyCodes.EUR]: PricePlansIds.zing_premium_1m_27_99_7d_trial_1_eur,
    [CurrencyCodes.MXN]: PricePlansIds.zing_premium_1m_329_99_7d_trial_10_99_mxn,
    [CurrencyCodes.ARS]: PricePlansIds.zing_premium_12m_39_99_7d_trial_1_usd,
    [CurrencyCodes.CLP]: PricePlansIds.zing_premium_12m_39_99_7d_trial_1_usd,
};

export const FRIENDS_TRIAL_PLANS_IDS: Record<CurrencyCodes, PricePlansIds> = {
    [CurrencyCodes.USD]: PricePlansIds.zing_premium_12m_59_99_7d_trial_0_usd,
    [CurrencyCodes.GBP]: PricePlansIds.zing_premium_12m_59_99_7d_trial_0_gpb,
    [CurrencyCodes.CAD]: PricePlansIds.zing_premium_12m_81_46_7d_trial_0_cad,
    [CurrencyCodes.AUD]: PricePlansIds.zing_premium_12m_89_99_7d_trial_0_aud,
    [CurrencyCodes.EUR]: PricePlansIds.zing_premium_12m_54_10_7d_trial_0_eur,
    [CurrencyCodes.MXN]: PricePlansIds.zing_premium_12m_658_7d_trial_0_mxn,
    [CurrencyCodes.ARS]: PricePlansIds.zing_premium_12m_54_10_7d_trial_0_eur,
    [CurrencyCodes.CLP]: PricePlansIds.zing_premium_12m_54_10_7d_trial_0_eur,
};

export const enum PlansPeriods {
    MONTH = "1-month",
    QUARTER = "3-month",
    SIX_MONTHS = "6-month",
    TWELVE_MONTHS = "12-month",
    YEAR = "1-year",
    WEEK_TRIAL = "7-days",
    WEEK = "1-week",
    FOUR_WEEK = "4-week",
    TWELVE_WEEK = "12-week",
    TWENTY_FOUR_WEEK = "24-week",
    YEAR_IN_WEEKS = "52-week",
    LIFETIME = "lifetime",
}

export const PLANS_IDS_BY_NAMES: { [key in PlansPeriods]: PricePlansIds[] } = {
    [PlansPeriods.MONTH]: [
        PricePlansIds.zing_premium_1m_29_84_intro_13_99_usd,
        PricePlansIds.zing_premium_1m_23_99_intro_17_06_usd,
        PricePlansIds.zing_premium_1m_29_99_intro_23_06_usd,
        PricePlansIds.zing_premium_bodyscan_1m_27_59_intro_19_60_usd,
        PricePlansIds.zing_premium_bodyscan_1m_34_49_intro_26_50_usd,
    ],
    [PlansPeriods.QUARTER]: [
        PricePlansIds.zing_premium_3m_71_99_intro_49_00_aud,
        PricePlansIds.zing_premium_3m_89_99_intro_67_00_aud,
        PricePlansIds.zing_premium_3m_59_99_intro_44_00_usd,
        PricePlansIds.zing_premium_3m_47_99_intro_32_00_usd,
        PricePlansIds.zing_premium_3m_59_99_intro_48_70_usd,
        PricePlansIds.zing_premium_3m_47_99_intro_36_70_usd,
        PricePlansIds.zing_premium_3m_59_99_intro_44_00_eur,
        PricePlansIds.zing_premium_3m_47_99_intro_32_00_eur,
        PricePlansIds.zing_premium_3m_59_99_intro_44_00_gbp,
        PricePlansIds.zing_premium_3m_47_99_intro_32_00_gbp,
        PricePlansIds.zing_premium_3m_79_99_intro_60_00_cad,
        PricePlansIds.zing_premium_3m_63_99_intro_44_00_cad,
        PricePlansIds.zing_premium_3m_699_99_intro_520_00_mxn,
        PricePlansIds.zing_premium_3m_559_99_intro_380_00_mxn,
        PricePlansIds.zing_premium_3m_44_77_intro_21_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_68_99_intro_50_60_usd,
        PricePlansIds.zing_premium_bodyscan_3m_55_29_intro_36_90_usd,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_44_00_usd,
        PricePlansIds.zing_premium_bodyscan_3m_47_99_intro_32_00_usd,
        PricePlansIds.zing_premium_bodyscan_3m_68_99_intro_50_00_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_54_99_intro_36_00_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_64_99_intro_47_60_eur,
        PricePlansIds.zing_premium_bodyscan_3m_51_99_intro_34_60_eur,
        PricePlansIds.zing_premium_bodyscan_3m_104_99_intro_77_20_aud,
        PricePlansIds.zing_premium_bodyscan_3m_83_49_intro_55_70_aud,
        PricePlansIds.zing_premium_bodyscan_3m_94_49_intro_69_30_cad,
        PricePlansIds.zing_premium_bodyscan_3m_75_69_intro_50_50_cad,
    ],
    [PlansPeriods.SIX_MONTHS]: [],
    [PlansPeriods.TWELVE_MONTHS]: [],
    [PlansPeriods.YEAR]: [
        PricePlansIds.zing_premium_12m_111_99_intro_74_00_aud,
        PricePlansIds.zing_premium_12m_139_99_intro_102_00_aud,
        PricePlansIds.zing_premium_12m_104_46_intro_78_47_usd,
        PricePlansIds.zing_premium_12m_83_67_intro_57_68_usd,
        PricePlansIds.zing_premium_12m_104_46_intro_85_17_usd,
        PricePlansIds.zing_premium_12m_83_67_intro_64_38_usd,
        PricePlansIds.zing_premium_12m_104_46_intro_78_47_eur,
        PricePlansIds.zing_premium_12m_83_67_intro_57_68_eur,
        PricePlansIds.zing_premium_12m_104_46_intro_78_47_gbp,
        PricePlansIds.zing_premium_12m_83_67_intro_57_68_gbp,
        PricePlansIds.zing_premium_12m_104_46_intro_54_99_usd,
        PricePlansIds.zing_premium_12m_139_99_intro_106_00_cad,
        PricePlansIds.zing_premium_12m_109_99_intro_76_00_cad,
        PricePlansIds.zing_premium_12m_1199_99_intro_900_00_mxn,
        PricePlansIds.zing_premium_12m_999_99_intro_700_00_mxn,
        PricePlansIds.zing_premium_bodyscan_12m_69_99_intro_69_99_usd,
        PricePlansIds.zing_premium_bodyscan_12m_119_99_intro_90_00_usd,
        PricePlansIds.zing_premium_bodyscan_12m_96_49_intro_66_50_usd,
        PricePlansIds.zing_premium_bodyscan_12m_104_46_intro_78_47_usd,
        PricePlansIds.zing_premium_bodyscan_12m_83_67_intro_57_68_usd,
        PricePlansIds.zing_premium_bodyscan_12m_119_99_intro_90_00_gbp,
        PricePlansIds.zing_premium_bodyscan_12m_95_99_intro_66_00_gbp,
        PricePlansIds.zing_premium_bodyscan_12m_112_69_intro_84_50_eur,
        PricePlansIds.zing_premium_bodyscan_12m_90_69_intro_62_50_eur,
        PricePlansIds.zing_premium_bodyscan_12m_180_99_intro_135_60_aud,
        PricePlansIds.zing_premium_bodyscan_12m_145_69_intro_100_30_aud,
        PricePlansIds.zing_premium_bodyscan_12m_164_39_intro_123_40_cad,
        PricePlansIds.zing_premium_bodyscan_12m_131_99_intro_91_00_cad,
    ],
    [PlansPeriods.WEEK_TRIAL]: [
        PricePlansIds.zing_premium_12m_104_46_7d_1_usd,
        PricePlansIds.zing_premium_12m_104_46_7d_1_gbp,
        PricePlansIds.zing_premium_12m_134_30_7d_1_cad,
        PricePlansIds.zing_premium_12m_149_24_7d_1_aud,
        PricePlansIds.zing_premium_12m_95_99_7d_0_eur,
        PricePlansIds.zing_premium_1m_329_99_7d_trial_10_99_mxn,
        PricePlansIds.zing_premium_12m_89_99_7d_trial_0_usd,
        PricePlansIds.zing_premium_12m_89_99_7d_trial_0_gbp,
        PricePlansIds.zing_premium_12m_125_99_7d_trial_0_cad,
        PricePlansIds.zing_premium_12m_85_99_7d_trial_0_eur,
        PricePlansIds.zing_premium_12m_138_99_7d_trial_0_aud,
    ],
    [PlansPeriods.WEEK]: [
        PricePlansIds.zing_premium_1w_7_99_intro_7_99_usd,
        PricePlansIds.zing_premium_1w_7_99_intro_7_99_eur,
        PricePlansIds.zing_premium_1w_7_99_intro_7_99_gbp,
        PricePlansIds.zing_premium_1w_11_99_intro_11_99_aud,
        PricePlansIds.zing_premium_1w_10_99_intro_10_99_cad,
        PricePlansIds.zing_premium_1w_89_intro_89_mxn,
        PricePlansIds.zing_premium_1m_38_95_7d_trial_6_93_usd,
        PricePlansIds.zing_premium_1m_38_95_7d_trial_6_93_eur,
        PricePlansIds.zing_premium_1m_38_95_7d_trial_5_15_usd,
        PricePlansIds.zing_premium_bodyscan_1w_7_99_intro_7_99_usd,
        PricePlansIds.zing_premium_bodyscan_1w_15_99_intro_15_99_usd,
        PricePlansIds.zing_premium_1m_38_95_7d_trial_6_93_gbp,
        PricePlansIds.zing_premium_1m_58_95_7d_trial_9_99_aud,
        PricePlansIds.zing_premium_1m_48_76_7d_trial_8_93_cad,
        PricePlansIds.zing_premium_1m_439_00_7d_trial_79_99_mxn,
        PricePlansIds.zing_premium_bodyscan_1m_44_79_7d_trial_7_99_usd,
        PricePlansIds.zing_premium_bodyscan_1m_44_99_7d_trial_7_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1m_38_95_7d_trial_6_93_usd,
        PricePlansIds.zing_premium_bodyscan_1m_41_99_7d_trial_7_49_eur,
        PricePlansIds.zing_premium_bodyscan_1m_57_69_7d_trial_11_99_aud,
        PricePlansIds.zing_premium_bodyscan_1m_61_39_7d_trial_10_89_cad,
        PricePlansIds.zing_premium_bodyscan_1w_6_99_intro_6_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1w_13_99_intro_13_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1w_8_99_intro_8_99_cad,
        PricePlansIds.zing_premium_bodyscan_1w_17_99_intro_17_99_cad,
        PricePlansIds.zing_premium_bodyscan_1w_10_99_intro_10_99_aud,
        PricePlansIds.zing_premium_bodyscan_1w_21_99_intro_21_99_aud,
        PricePlansIds.zing_premium_bodyscan_1w_7_99_intro_7_99_eur,
        PricePlansIds.zing_premium_bodyscan_1w_15_99_intro_15_99_eur,
        PricePlansIds.zing_premium_bodyscan_1w_89_intro_89_mxn,
        PricePlansIds.zing_premium_bodyscan_1w_179_99_intro_179_99_mxn,
        PricePlansIds.zing_premium_1w_4699_intro_4699_ars,
        PricePlansIds.zing_premium_1w_5190_intro_5190_clp,
    ],
    [PlansPeriods.FOUR_WEEK]: [
        PricePlansIds.zing_premium_1m_38_95_intro_15_99_usd,
        PricePlansIds.zing_premium_1m_38_95_intro_11_29_usd,
        PricePlansIds.zing_premium_1m_38_95_intro_15_99_gbp,
        PricePlansIds.zing_premium_1m_48_76_intro_19_99_cad,
        PricePlansIds.zing_premium_1m_439_00_intro_179_99_mxn,
        PricePlansIds.zing_premium_1m_419_intro_209_mxn,
        PricePlansIds.zing_premium_1m_58_95_intro_22_99_aud,
        PricePlansIds.zing_premium_1m_38_95_intro_15_99_eur,
        PricePlansIds.zing_premium_bodyscan_1m_44_79_intro_18_39_usd,
        PricePlansIds.zing_premium_bodyscan_1m_38_95_intro_15_99_usd,
        PricePlansIds.zing_premium_bodyscan_1m_44_99_intro_18_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1m_41_99_intro_17_39_eur,
        PricePlansIds.zing_premium_bodyscan_1m_57_69_intro_27_79_aud,
        PricePlansIds.zing_premium_bodyscan_1m_61_39_intro_25_19_cad,
        PricePlansIds.zing_premium_bodyscan_1m_18_39_intro_18_39_usd,
        PricePlansIds.zing_premium_bodyscan_1m_37_99_intro_18_99_usd,
        PricePlansIds.zing_premium_bodyscan_1m_37_99_intro_37_99_usd,
        PricePlansIds.zing_premium_bodyscan_1m_29_99_intro_14_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1m_29_99_intro_29_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1m_43_99_intro_21_99_cad,
        PricePlansIds.zing_premium_bodyscan_1m_43_99_intro_43_99_cad,
        PricePlansIds.zing_premium_bodyscan_1m_47_48_intro_18_99_cad,
        PricePlansIds.zing_premium_bodyscan_1m_49_99_intro_24_99_aud,
        PricePlansIds.zing_premium_bodyscan_1m_49_99_intro_49_99_aud,
        PricePlansIds.zing_premium_bodyscan_1m_49_98_intro_19_99_aud,
        PricePlansIds.zing_premium_bodyscan_1m_37_99_intro_18_99_eur,
        PricePlansIds.zing_premium_bodyscan_1m_37_99_intro_37_99_eur,
        PricePlansIds.zing_premium_bodyscan_1m_38_95_intro_15_99_eur,
        PricePlansIds.zing_premium_bodyscan_1m_34_97_intro_13_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1m_419_intro_209_mxn,
        PricePlansIds.zing_premium_bodyscan_1m_419_intro_419_mxn,
        PricePlansIds.zing_premium_1m_22899_intro_9399_ars,
        PricePlansIds.zing_premium_1m_24990_intro_10490_clp,
    ],
    [PlansPeriods.TWELVE_WEEK]: [
        PricePlansIds.zing_premium_3m_66_65_intro_25_99_usd,
        PricePlansIds.zing_premium_3m_66_65_intro_19_29_usd,
        PricePlansIds.zing_premium_3m_66_65_intro_25_99_gbp,
        PricePlansIds.zing_premium_3m_82_90_intro_33_99_cad,
        PricePlansIds.zing_premium_3m_731_70_intro_299_99_mxn,
        PricePlansIds.zing_premium_3m_659_intro_329_mxn,
        PricePlansIds.zing_premium_3m_66_65_intro_25_99_eur,
        PricePlansIds.zing_premium_3m_97_41_intro_37_99_aud,
        PricePlansIds.zing_premium_bodyscan_3m_76_59_intro_29_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_66_65_intro_25_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_29_99_intro_29_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_76_99_intro_29_99_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_71_99_intro_28_19_eur,
        PricePlansIds.zing_premium_bodyscan_3m_115_69_intro_45_39_aud,
        PricePlansIds.zing_premium_bodyscan_3m_104_99_intro_40_99_cad,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_29_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_59_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_49_99_intro_24_99_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_49_99_intro_49_99_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_59_98_intro_23_99_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_67_99_intro_33_99_cad,
        PricePlansIds.zing_premium_bodyscan_3m_67_99_intro_67_99_cad,
        PricePlansIds.zing_premium_bodyscan_3m_74_98_intro_29_99_cad,
        PricePlansIds.zing_premium_bodyscan_3m_79_99_intro_39_99_aud,
        PricePlansIds.zing_premium_bodyscan_3m_79_99_intro_79_99_aud,
        PricePlansIds.zing_premium_bodyscan_3m_82_48_intro_32_99_aud,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_29_99_eur,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_59_99_eur,
        PricePlansIds.zing_premium_bodyscan_3m_66_65_intro_25_99_eur,
        PricePlansIds.zing_premium_bodyscan_3m_659_intro_329_mxn,
        PricePlansIds.zing_premium_bodyscan_3m_659_intro_659_mxn,
        PricePlansIds.zing_premium_3m_39199_intro_15299_ars,
        PricePlansIds.zing_premium_3m_42990_intro_16990_clp,
    ],
    [PlansPeriods.TWENTY_FOUR_WEEK]: [],
    [PlansPeriods.YEAR_IN_WEEKS]: [
        PricePlansIds.zing_premium_12m_109_99_intro_65_99_usd,
        PricePlansIds.zing_premium_12m_104_99_intro_62_99_eur,
    ],
    [PlansPeriods.LIFETIME]: [PricePlansIds.zing_premium_bodyscan_lifetime_139_99_usd],
};

export const OFFER_FUNNEL_PRICE_PLANS_IDS_BY_CURRENCY: {
    [key in CurrencyCodes]?: PricePlansIds[];
} = {
    [CurrencyCodes.USD]: [
        PricePlansIds.zing_premium_bodyscan_1m_18_39_intro_18_39_usd,
        PricePlansIds.zing_premium_bodyscan_12m_69_99_intro_69_99_usd,
        PricePlansIds.zing_premium_bodyscan_lifetime_139_99_usd,
    ],
};

export const DISCOUNT_PRICE_PLANS_IDS_BY_CURRENCY: {
    [key in CurrencyCodes]?: PricePlansIds[];
} = {
    [CurrencyCodes.USD]: [
        PricePlansIds.zing_premium_bodyscan_1w_7_99_intro_7_99_usd,
        PricePlansIds.zing_premium_bodyscan_1m_37_99_intro_18_99_usd,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_29_99_usd,
    ],
    [CurrencyCodes.EUR]: [
        PricePlansIds.zing_premium_bodyscan_1w_7_99_intro_7_99_eur,
        PricePlansIds.zing_premium_bodyscan_1m_37_99_intro_18_99_eur,
        PricePlansIds.zing_premium_bodyscan_3m_59_99_intro_29_99_eur,
    ],
    [CurrencyCodes.GBP]: [
        PricePlansIds.zing_premium_bodyscan_1w_6_99_intro_6_99_gbp,
        PricePlansIds.zing_premium_bodyscan_1m_29_99_intro_14_99_gbp,
        PricePlansIds.zing_premium_bodyscan_3m_49_99_intro_24_99_gbp,
    ],
    [CurrencyCodes.AUD]: [
        PricePlansIds.zing_premium_bodyscan_1w_10_99_intro_10_99_aud,
        PricePlansIds.zing_premium_bodyscan_1m_49_99_intro_24_99_aud,
        PricePlansIds.zing_premium_bodyscan_3m_79_99_intro_39_99_aud,
    ],
    [CurrencyCodes.CAD]: [
        PricePlansIds.zing_premium_bodyscan_1w_8_99_intro_8_99_cad,
        PricePlansIds.zing_premium_bodyscan_1m_43_99_intro_21_99_cad,
        PricePlansIds.zing_premium_bodyscan_3m_67_99_intro_33_99_cad,
    ],
    [CurrencyCodes.MXN]: [
        PricePlansIds.zing_premium_bodyscan_1w_89_intro_89_mxn,
        PricePlansIds.zing_premium_bodyscan_1m_419_intro_209_mxn,
        PricePlansIds.zing_premium_bodyscan_3m_659_intro_329_mxn,
    ],
};

export const PRICE_PLANS_IDS_BY_CURRENCY = (
    isYearPlanExp?: boolean
): {
    [key in CurrencyCodes]?: PricePlansIds[];
} => ({
    [CurrencyCodes.USD]: isYearPlanExp
        ? [
              PricePlansIds.zing_premium_1w_7_99_intro_7_99_usd,
              PricePlansIds.zing_premium_3m_66_65_intro_25_99_usd,
              PricePlansIds.zing_premium_12m_109_99_intro_65_99_usd,
          ]
        : [
              PricePlansIds.zing_premium_1w_7_99_intro_7_99_usd,
              PricePlansIds.zing_premium_1m_38_95_intro_15_99_usd,
              PricePlansIds.zing_premium_3m_66_65_intro_25_99_usd,
          ],
    [CurrencyCodes.EUR]: isYearPlanExp
        ? [
              PricePlansIds.zing_premium_1w_7_99_intro_7_99_eur,
              PricePlansIds.zing_premium_3m_66_65_intro_25_99_eur,
              PricePlansIds.zing_premium_12m_104_99_intro_62_99_eur,
          ]
        : [
              PricePlansIds.zing_premium_1w_7_99_intro_7_99_eur,
              PricePlansIds.zing_premium_1m_38_95_intro_15_99_eur,
              PricePlansIds.zing_premium_3m_66_65_intro_25_99_eur,
          ],
    [CurrencyCodes.GBP]: [
        PricePlansIds.zing_premium_1w_7_99_intro_7_99_gbp,
        PricePlansIds.zing_premium_1m_38_95_intro_15_99_gbp,
        PricePlansIds.zing_premium_3m_66_65_intro_25_99_gbp,
    ],
    [CurrencyCodes.AUD]: [
        PricePlansIds.zing_premium_1w_11_99_intro_11_99_aud,
        PricePlansIds.zing_premium_1m_58_95_intro_22_99_aud,
        PricePlansIds.zing_premium_3m_97_41_intro_37_99_aud,
    ],
    [CurrencyCodes.CAD]: [
        PricePlansIds.zing_premium_1w_10_99_intro_10_99_cad,
        PricePlansIds.zing_premium_1m_48_76_intro_19_99_cad,
        PricePlansIds.zing_premium_3m_82_90_intro_33_99_cad,
    ],
    [CurrencyCodes.MXN]: [
        PricePlansIds.zing_premium_1w_89_intro_89_mxn,
        PricePlansIds.zing_premium_1m_419_intro_209_mxn,
        PricePlansIds.zing_premium_3m_659_intro_329_mxn,
    ],
    [CurrencyCodes.ARS]: [
        PricePlansIds.zing_premium_1w_4699_intro_4699_ars,
        PricePlansIds.zing_premium_1m_22899_intro_9399_ars,
        PricePlansIds.zing_premium_3m_39199_intro_15299_ars,
    ],
    [CurrencyCodes.CLP]: [
        PricePlansIds.zing_premium_1w_5190_intro_5190_clp,
        PricePlansIds.zing_premium_1m_24990_intro_10490_clp,
        PricePlansIds.zing_premium_3m_42990_intro_16990_clp,
    ],
});

export const getPlanName = (planId: PricePlansIds | null | undefined): PlansPeriods | null => {
    if (planId) {
        for (const key in PLANS_IDS_BY_NAMES) {
            const name = key as PlansPeriods;
            if (
                Array.isArray(PLANS_IDS_BY_NAMES[name]) &&
                PLANS_IDS_BY_NAMES[name].includes(planId)
            ) {
                return name;
            }
        }
    }

    return null;
};

export const getEmailInitialSelectedPlanId = (currency: CurrencyCodes) =>
    EMAIL_MB_PLANS_IDS[currency];

export const getFriendsInitialSelectedTrialPlanId = (currency: CurrencyCodes) =>
    FRIENDS_TRIAL_PLANS_IDS[currency];

export const getPlanPeriod = ({ isOfferFlow }: { isOfferFlow?: boolean }) => {
    if (isOfferFlow) {
        return PlansPeriods.YEAR;
    }

    return PlansPeriods.TWELVE_WEEK;
};

export const getInitialSelectedPlanId = ({
    currency,
    isOfferFlow = false,
    isYearPlanExp = false,
}: {
    currency: CurrencyCodes;
    isOfferFlow?: boolean;
    isYearPlanExp?: boolean;
}): PricePlansIds | null => {
    const planPeriod = getPlanPeriod({
        isOfferFlow,
    });
    const pricePlansIdsByCurrency = getPricePlansIds({
        isOfferFlow,
        isYearPlanExp,
    });
    // TODO: remove question mark after isFemaleBetterMePricesTest will be removed
    return (
        pricePlansIdsByCurrency[currency]?.find((i) =>
            PLANS_IDS_BY_NAMES[planPeriod].includes(i)
        ) || null
    );
};
export const POPULAR_PRICES_IDS = PLANS_IDS_BY_NAMES[PlansPeriods.FOUR_WEEK];
export const OFFER_PRICES_POPULAR_IDS = PLANS_IDS_BY_NAMES[PlansPeriods.YEAR];

export const PeriodNameToDays: Record<SubscriptionsPeriods, Record<number, number>> = {
    [SubscriptionsPeriods.MONTH]: {
        1: 30,
        3: 90,
        6: 180,
        12: 360,
    },
    [SubscriptionsPeriods.WEEK]: {
        1: 7,
    },
    [SubscriptionsPeriods.DAY]: {
        1: 1,
        7: 7,
    },
    [SubscriptionsPeriods.MINUTE]: {
        5: 1,
    },
};

export const DayCountByPlansPeriods: { [key in PlansPeriods]: number } = {
    [PlansPeriods.MONTH]: 30,
    [PlansPeriods.QUARTER]: 90,
    [PlansPeriods.SIX_MONTHS]: 180,
    [PlansPeriods.TWELVE_MONTHS]: 360,
    [PlansPeriods.YEAR]: 360,
    [PlansPeriods.YEAR_IN_WEEKS]: 360,
    [PlansPeriods.WEEK]: 7,
    [PlansPeriods.WEEK_TRIAL]: 7,
    [PlansPeriods.FOUR_WEEK]: 30,
    [PlansPeriods.TWELVE_WEEK]: 90,
    [PlansPeriods.TWENTY_FOUR_WEEK]: 168,
    [PlansPeriods.LIFETIME]: 0,
};

export const MonthCountByPlansPeriods: { [key in PlansPeriods]?: number } = {
    [PlansPeriods.MONTH]: 1,
    [PlansPeriods.FOUR_WEEK]: 1,
    [PlansPeriods.QUARTER]: 3,
    [PlansPeriods.TWELVE_WEEK]: 3,
    [PlansPeriods.SIX_MONTHS]: 6,
    [PlansPeriods.TWELVE_MONTHS]: 12,
    [PlansPeriods.YEAR]: 12,
    [PlansPeriods.LIFETIME]: 0,
};

export type DayPrices = { introDayPrice: string | null; regularDayPrice: string | null };

export const calculateDevDayPrices = (
    { introBasePrice, nextBasePrice }: PricePoint,
    basePeriod: PlansPeriods | null
): DayPrices | null => {
    if (basePeriod && introBasePrice && nextBasePrice) {
        const period = Number(introBasePrice) ? basePeriod : PlansPeriods.YEAR;
        const daysAmount = DayCountByPlansPeriods[period];
        const introDayPrice = daysAmount
            ? (Math.round((+introBasePrice / daysAmount) * 100) / 100).toFixed(2)
            : null;

        let regularDayPrice;

        if (period === PlansPeriods.WEEK) {
            const nextPeriodDaysAmount = DayCountByPlansPeriods[PlansPeriods.WEEK];
            const oldFullPrice =
                Math.round(
                    (Number(introBasePrice) * 100 * 100) / (100 - WEEKLY_DISCOUNT_PERCENTAGE)
                ) / 100;
            regularDayPrice = daysAmount
                ? (Math.round((oldFullPrice / nextPeriodDaysAmount) * 100) / 100).toFixed(2)
                : null;
        } else {
            regularDayPrice = daysAmount
                ? (Math.round((+nextBasePrice / daysAmount) * 100) / 100).toFixed(2)
                : null;
        }

        return { introDayPrice, regularDayPrice };
    }

    return null;
};

export const calculateProdDayPrices = ({
    ident,
    introBasePrice,
    nextBasePrice,
    nextPeriodType,
    nextPeriodValue,
    introPeriodType,
    introPeriodValue,
}: PricePoint): DayPrices | null => {
    if (
        introBasePrice &&
        nextBasePrice &&
        nextPeriodType &&
        nextPeriodValue &&
        introPeriodType &&
        introPeriodValue
    ) {
        let regularDayPrice;
        const introDayAmount =
            PeriodNameToDays[introPeriodType as unknown as SubscriptionsPeriods]?.[
                introPeriodValue
            ];
        const introDayPrice = (Math.round((+introBasePrice / introDayAmount) * 100) / 100).toFixed(
            2
        );
        const priceName = getPlanName(ident as PricePlansIds);
        if (priceName === PlansPeriods.WEEK) {
            const weeklyTrialOldPrice = getWeeklyTrialPlanOldPrice({
                introBasePrice,
            } as PricePoint);
            const introDayAmount =
                PeriodNameToDays[introPeriodType as unknown as SubscriptionsPeriods]?.[
                    introPeriodValue
                ];

            regularDayPrice = (
                Math.round((+weeklyTrialOldPrice / introDayAmount) * 100) / 100
            ).toFixed(2);
        } else {
            const regularDaysAmount =
                PeriodNameToDays[nextPeriodType as unknown as SubscriptionsPeriods][
                    nextPeriodValue
                ];
            regularDayPrice = (
                Math.round((+nextBasePrice / regularDaysAmount) * 100) / 100
            ).toFixed(2);
        }

        return { introDayPrice, regularDayPrice };
    }
    return null;
};

const WEEKLY_DISCOUNT_PERCENTAGE = 50;

export const getPriceDiscountLabel = (price: PricePoint | null) => {
    const priceName = getPlanName(price?.ident as PricePlansIds);
    if (price && (priceName === PlansPeriods.FOUR_WEEK || priceName === PlansPeriods.TWELVE_WEEK)) {
        return 100 - Math.round((Number(price.introBasePrice) * 100) / Number(price.nextBasePrice));
    } else if (price && priceName === PlansPeriods.WEEK) {
        return WEEKLY_DISCOUNT_PERCENTAGE;
    }

    return WEEKLY_DISCOUNT_PERCENTAGE;
};

export const UPGRADE_SUB_PLANS: {
    [key in PricePlansIds]?: (isExtraDiscount: boolean) => PricePlansIds;
} = {
    [PricePlansIds.zing_premium_1m_38_95_7d_trial_6_93_usd]: (isExtraDiscount) =>
        isExtraDiscount
            ? PricePlansIds.zing_premium_1m_23_99_intro_17_06_usd
            : PricePlansIds.zing_premium_1m_29_99_intro_23_06_usd,
    [PricePlansIds.zing_premium_bodyscan_1m_44_79_7d_trial_7_99_usd]: (isExtraDiscount) =>
        isExtraDiscount
            ? PricePlansIds.zing_premium_bodyscan_1m_27_59_intro_19_60_usd
            : PricePlansIds.zing_premium_bodyscan_1m_34_49_intro_26_50_usd,
};

const getOldPriceCalcFunctionByPlanName: {
    [key in PlansPeriods]?: (plan: PricePoint | null) => number;
} = {
    [PlansPeriods.WEEK]: (plan: PricePoint | null) => {
        const nextPeriodsCount = 1;
        return Number(plan?.introBasePrice) + Number(plan?.nextBasePrice) * nextPeriodsCount;
    },
    [PlansPeriods.FOUR_WEEK]: (plan: PricePoint | null) => {
        const nextPeriodsCount = 2;
        return Number(plan?.introBasePrice) + Number(plan?.nextBasePrice) * nextPeriodsCount;
    },
    [PlansPeriods.MONTH]: (plan: PricePoint | null) => {
        const nextPeriodsCount = 2;
        return Number(plan?.introBasePrice) + Number(plan?.nextBasePrice) * nextPeriodsCount;
    },
    [PlansPeriods.QUARTER]: (plan: PricePoint | null) => {
        const nextPeriodsCount = 3;

        return Number(plan?.introBasePrice) + Number(plan?.nextBasePrice) * nextPeriodsCount;
    },
    [PlansPeriods.TWELVE_WEEK]: (plan: PricePoint | null) => {
        const nextPeriodsCount = 3;
        return Number(plan?.introBasePrice) + Number(plan?.nextBasePrice) * nextPeriodsCount;
    },
    [PlansPeriods.SIX_MONTHS]: (plan: PricePoint | null) => {
        return Number(plan?.introBasePrice) + Number(plan?.nextBasePrice);
    },
};

export const calculateUpgradeSubPrices = (
    pricePoints: PricePoint[] | undefined,
    currentPlan: PricePoint | null,
    isExtraDiscount: boolean
) => {
    const currentPlanId = currentPlan?.ident as PricePlansIds;
    const currentPlanPeriod = getPlanName(currentPlanId);
    const currentPriceCalc =
        currentPlanPeriod && getOldPriceCalcFunctionByPlanName[currentPlanPeriod];
    const currentPrice = Number(currentPriceCalc && currentPriceCalc(currentPlan));

    const newIntroPlanId = UPGRADE_SUB_PLANS[currentPlanId]?.(false);
    const newDiscountedPlanId = UPGRADE_SUB_PLANS[currentPlanId]?.(true);

    const newIntroPlanPeriod = getPlanName(newIntroPlanId);
    const newDiscountedPlanPeriod = getPlanName(newDiscountedPlanId);

    const newIntroPlan = pricePoints?.find((plan) => plan.ident === newIntroPlanId);
    const newDiscountedPlan = pricePoints?.find((plan) => plan.ident === newDiscountedPlanId);

    const newIntroPrice = Number(newIntroPlan?.nextBasePrice);
    const newDiscountedPrice = Number(newDiscountedPlan?.nextBasePrice);

    const introDiscount = currentPrice - newIntroPrice;
    const extraDiscount = currentPrice - newDiscountedPrice;

    const refund = Number(currentPlan?.introBasePrice);
    const introTotalNow = newIntroPrice - refund;
    const discountedTotalNow = newDiscountedPrice - refund;
    const introDiscountPercentage = Math.round((1 - newIntroPrice / currentPrice) * 10) * 10;
    const extraDiscountPercentage = Math.round((1 - newDiscountedPrice / currentPrice) * 10) * 10;

    return {
        currentPlanPeriod,
        currentPrice: currentPrice.toFixed(2),
        newPlanId: isExtraDiscount ? newDiscountedPlanId : newIntroPlanId,
        newPlanPeriod: isExtraDiscount ? newDiscountedPlanPeriod : newIntroPlanPeriod,
        newPrice: isExtraDiscount ? newDiscountedPrice : newIntroPrice,
        introDiscount: introDiscount.toFixed(2),
        extraDiscount: extraDiscount.toFixed(2),
        introTotalNow: introTotalNow.toFixed(2),
        discountedTotalNow: discountedTotalNow.toFixed(2),
        refund: refund.toFixed(2),
        introDiscountPercentage,
        extraDiscountPercentage,
    };
};

export const getPlanNameLabel = (planName: PlansPeriods | null, isAdjective = true) =>
    planName
        ? {
              [PlansPeriods.WEEK]: isAdjective ? i18n.t("1_week") : i18n.t("1_week_noun"),
              [PlansPeriods.WEEK_TRIAL]: isAdjective ? i18n.t("7_days") : i18n.t("7_days_noun"),
              [PlansPeriods.FOUR_WEEK]: isAdjective ? i18n.t("4_week") : i18n.t("4_weeks_noun"),
              [PlansPeriods.MONTH]: isAdjective ? i18n.t("1_month") : i18n.t("1_month_noun"),
              [PlansPeriods.QUARTER]: isAdjective ? i18n.t("3_month") : i18n.t("3_months_noun"),
              [PlansPeriods.SIX_MONTHS]: isAdjective ? i18n.t("6_month") : i18n.t("6_months_noun"),
              [PlansPeriods.TWELVE_WEEK]: isAdjective ? i18n.t("12_week") : i18n.t("12_weeks_noun"),
              [PlansPeriods.TWENTY_FOUR_WEEK]: isAdjective
                  ? i18n.t("24_week")
                  : i18n.t("24_weeks_noun"),
              [PlansPeriods.TWELVE_MONTHS]: isAdjective ? "12-month" : "12 months",
              [PlansPeriods.YEAR]: isAdjective ? i18n.t("1_year") : i18n.t("1_year_noun"),
              [PlansPeriods.YEAR_IN_WEEKS]: isAdjective ? "52-week" : "52 weeks",
              [PlansPeriods.LIFETIME]: "lifetime",
          }[planName]
        : "";

export const getPeriodLabel = (period: string, count = 1) =>
    ({
        day: i18n.t("day", { count }),
        month: i18n.t("month", { count }),
        minute: i18n.t("minute", { count }),
        year: i18n.t("year", { count }),
        week: i18n.t("week", { count }),
    })[period] ?? period;

export const getUpdatedPeriodLabel = (defaultPeriod: string, defaultCount = 1) => {
    let period = defaultPeriod;
    let count = defaultCount;
    if (period === SubscriptionsPeriods.MONTH && count === 3) {
        period = "quarter";
        count = 1;
    } else if (period === SubscriptionsPeriods.DAY && count === 7) {
        period = SubscriptionsPeriods.WEEK;
        count = 1;
    }

    return (
        {
            day: i18n.t("daily", { count }),
            month: i18n.t("monthly", { count }),
            quarter: i18n.t("quarterly", { count }),
            minute: i18n.t("minutely", { count }),
            year: i18n.t("yearly", { count }),
            week: i18n.t("weekly", { count }),
        }[period] ?? period
    );
};

export const getWeeklyTrialPlanOldPrice = (plan: PricePoint | null) =>
    Math.round((Number(plan?.introBasePrice) * 100 * 100) / (100 - WEEKLY_DISCOUNT_PERCENTAGE)) /
    100;

export const oldPriceByNewPricePoint = {
    // friends paywall
    [PricePlansIds.zing_premium_12m_59_99_7d_trial_0_usd]: "104",
    [PricePlansIds.zing_premium_12m_59_99_7d_trial_0_gpb]: "104",
    [PricePlansIds.zing_premium_12m_81_46_7d_trial_0_cad]: "134",
    [PricePlansIds.zing_premium_12m_89_99_7d_trial_0_aud]: "149",
    [PricePlansIds.zing_premium_12m_54_10_7d_trial_0_eur]: "95",
    [PricePlansIds.zing_premium_12m_658_7d_trial_0_mxn]: "1147",
    // abandon paywall
    [PricePlansIds.zing_premium_12m_39_99_7d_trial_1_usd]: "59.99",
    // TODO: add other currencies variants when they'll be available
};

export const weeklyCrossedOutPriceByCurrency: { [key in CurrencyCodes]?: number } = {
    [CurrencyCodes.USD]: 15.99,
    [CurrencyCodes.EUR]: 15.99,
    [CurrencyCodes.GBP]: 13.99,
    [CurrencyCodes.AUD]: 21.99,
    [CurrencyCodes.CAD]: 17.99,
    [CurrencyCodes.MXN]: 179.99,
    [CurrencyCodes.ARS]: 12049,
    [CurrencyCodes.CLP]: 13308,
};
